import { PageTitleProps } from "./type";

const PageTitle = (props: PageTitleProps): React.ReactElement => {
  const { title, className } = props;
  return (
    <h1
      className={`max-xs:text-[22px] xs:text-[26px] sm:text-2xl font-medium tracking-[-0.1px] leading-normal ${className ?? ""}`}
    >
      {title}
    </h1>
  );
};

export default PageTitle;
